import { render, staticRenderFns } from "./ResguardoSubTipo.vue?vue&type=template&id=65af83e8"
import script from "./ResguardoSubTipo.vue?vue&type=script&lang=js"
export * from "./ResguardoSubTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports